import styled from 'styled-components'

export const Input = styled.label`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`

export const Label = styled.span`
  font-size: 20px;
  margin-bottom: 10px;
`



// WEBPACK FOOTER //
// ./src/elements/Form.js